import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";

import ReactTable from "react-table";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CollectionOverride from "components/CollectionOverride";
import APPCONFIG from "../../constants/Config";
import {Button} from "reactstrap";


export default class LogsLocations extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Locations_Logs._name, API.RequestType.READ_ALL);
		super(props, model);

	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Location",
				id: "location",
				/** @param {Locations_Logs_Object} obj */
				accessor: obj => obj.locations ? (obj.locations.name_display || obj.locations.name) : ''
			},
			{
				Header: "Date Changed",
				id: "date",
				/** @param {Locations_Logs_Object} obj */
				accessor: obj => {
					return obj.date ? moment(obj.date).local().format("MM/DD/YYYY") : '-'
				}
			},
			{
				Header: "User",
				id: "user",
				/** @param {Locations_Logs_Object} obj */
				accessor: obj => (obj.user ? obj.user : 'Owner')
			},
			{
				Header: "Original",
				id: "value_original",
				/** @param {Locations_Logs_Object} obj */
				accessor: obj => (obj.value_original ? obj.value_original : "Blank")
			},
			{
				Header: "New",
				id: "value_new",
				/** @param {Locations_Logs_Object} obj */
				accessor: obj => (obj.value_new)
			},
			{
				Header: "Note",
				id: "note",
				/** @param {Locations_Logs_Object} obj */
				accessor: obj => (obj.note)
			},
			{
				Header: "Archive Signature",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 250,
				/** @param {Locations_Logs_Object} props */
				Cell: props => {
					return (
						<span>
							<a href={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + `/locations/logs/image?image=${props.original.locations.archive_signature}`} target="_blank">
								<Button color="blue-hoki" size={"sm"} block={true} >
									<i className={"fa fa-cloud-download"}/> View Signature
								</Button>
							</a>
						</span>
					);
				}
			}
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Location Logs', "")}
							{this.renderHeaderRight("Location Logs", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
